<template>
  <div class="modern-carousel-wrapper">
    <v-carousel
      cycle
      :height="carouselHeight"
      hide-delimiter-background
      show-arrows-on-hover
      interval="5000"
      class="modern-carousel"
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
        class="carousel-item"
      >

        <div class="image-gradient"></div>
      </v-carousel-item>
    </v-carousel>

    <!-- Custom Navigation Dots -->
    <div class="custom-dots">
      <div
        v-for="(item, index) in items"
        :key="`dot-${index}`"
        class="dot"
        :class="{ active: currentSlide === index }"
        @click="goToSlide(index)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentSlide: 0,
      items: [
        {
          src: 'https://cltts-gallery.s3.amazonaws.com/FrontPhotos/cv_2026.jpeg',
          title: 'Chithirai Thiruvizha 2026',
          subtitle: 'Join us for the grand matrimonial event'
        },
        {
          src: 'https://cltts-gallery.s3.amazonaws.com/FrontPhotos/Pongal_2026.jpeg',
          title: 'Pre Pongal Vizha 2026',
          subtitle: 'Join us for the grand matrimonial event'
        },
        {
          src: 'https://cltts-gallery.s3.amazonaws.com/FrontPhotos/parai2026.jpeg',
          title: 'Parai Team Performance',
          subtitle: 'Experience traditional Tamil drumming'
        },
        {
          src: 'https://cltts-gallery.s3.amazonaws.com/FrontPhotos/pv_2026_karakattam.jpeg',
          title: 'Cultural Celebration',
          subtitle: 'Celebrating Tamil heritage and culture'
        },
        {
          src: 'https://cltts-gallery.s3.amazonaws.com/photos/pongal_2023_2.jpg',
          title: 'Pongal Festival 2023',
          subtitle: 'Traditional harvest festival celebration'
        }
      ]
    }
  },
  computed: {
    carouselHeight() {
      if (this.$vuetify.breakpoint.xs) return '315px'
      if (this.$vuetify.breakpoint.sm) return '405px'
      if (this.$vuetify.breakpoint.md) return '468px'
      return '522px'
    }
  },
  methods: {
    navigateToReserve() {
      window.location.href = 'https://www.charlottetamilsangam.org/#/ReserveMe'
    },
    goToSlide(index) {
      this.currentSlide = index
      // Trigger carousel change if needed
    }
  },
  mounted() {
    // Track current slide
    setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.items.length
    }, 5000)
  }
}
</script>


<style scoped lang="scss">
* {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

/* Modern Carousel Wrapper */
.modern-carousel-wrapper {
  position: relative !important;
  width: 96% !important;
  overflow: hidden !important;
  margin: 0 auto !important;
  border-radius: 32px !important;
  box-shadow:
    0 12px 48px rgba(0, 0, 0, 0.15),
    0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

.modern-carousel {
  border-radius: 32px !important;
  overflow: hidden !important;
  width: 100% !important;
}

/* Carousel Item */
.carousel-item {
  position: relative !important;
}

.carousel-item ::v-deep img {
  width: 90% !important;
  margin: 0 auto !important;
  display: block !important;
  object-fit: cover !important;
}

/* Image Gradient Overlay */
.image-gradient {
  position: absolute !important;
  inset: 0 !important;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1) 0%,
    rgba(0, 0, 0, 0.3) 50%,
    rgba(0, 0, 0, 0.7) 100%
  ) !important;
  pointer-events: none !important;
  z-index: 1 !important;
}

/* Carousel Overlay */
.carousel-overlay {
  position: absolute !important;
  inset: 0 !important;
  display: flex !important;
  align-items: flex-end !important;
  justify-content: center !important;
  padding: 48px 24px !important;
  z-index: 2 !important;
  border-radius: 32px !important;
}

.carousel-content {
  text-align: center !important;
  max-width: 800px !important;
  animation: slideUp 0.8s ease-out !important;
}

.content-badge {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  background: rgba(102, 126, 234, 0.9) !important;
  backdrop-filter: blur(10px) !important;
  color: white !important;
  padding: 8px 20px !important;
  border-radius: 50px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  margin-bottom: 20px !important;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4) !important;
  letter-spacing: 0.5px !important;
}

.carousel-title {
  font-size: 48px !important;
  font-weight: 900 !important;
  color: white !important;
  margin: 0 0 16px 0 !important;
  text-shadow:
    0 4px 12px rgba(0, 0, 0, 0.5),
    0 2px 4px rgba(0, 0, 0, 0.3) !important;
  letter-spacing: -1px !important;
  line-height: 1.2 !important;
}

.carousel-subtitle {
  font-size: 20px !important;
  color: rgba(255, 255, 255, 0.95) !important;
  margin: 0 0 32px 0 !important;
  font-weight: 500 !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;
  letter-spacing: 0.3px !important;
}

/* CTA Button */
.carousel-cta-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  padding: 24px 48px !important;
  border-radius: 50px !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow:
    0 8px 24px rgba(102, 126, 234, 0.5),
    0 0 40px rgba(102, 126, 234, 0.3),
    inset 0 2px 4px rgba(255, 255, 255, 0.2) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.carousel-cta-btn::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: -100% !important;
  width: 100% !important;
  height: 100% !important;
  background: linear-gradient(90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent) !important;
  transition: left 0.5s ease !important;
}

.carousel-cta-btn:hover::before {
  left: 100% !important;
}

.carousel-cta-btn:hover {
  transform: translateY(-4px) scale(1.05) !important;
  box-shadow:
    0 12px 40px rgba(102, 126, 234, 0.6),
    0 0 60px rgba(102, 126, 234, 0.4),
    inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
}

/* Custom Navigation Dots */
.custom-dots {
  position: absolute !important;
  bottom: 24px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  display: flex !important;
  gap: 12px !important;
  z-index: 3 !important;
  padding: 12px 24px !important;
  background: rgba(0, 0, 0, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 50px !important;
}

.dot {
  width: 12px !important;
  height: 12px !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.4) !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  border: 2px solid transparent !important;
}

.dot:hover {
  background: rgba(255, 255, 255, 0.6) !important;
  transform: scale(1.2) !important;
}

.dot.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  width: 32px !important;
  border-radius: 50px !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 0 12px rgba(102, 126, 234, 0.6) !important;
}

/* Animations */
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .modern-carousel-wrapper {
    margin: 0 !important;
    border-radius: 24px !important;
  }

  .modern-carousel {
    border-radius: 24px !important;
  }

  .carousel-overlay {
    padding: 40px 20px !important;
    border-radius: 24px !important;
  }

  .carousel-title {
    font-size: 32px !important;
  }

  .carousel-subtitle {
    font-size: 17px !important;
    margin-bottom: 24px !important;
  }

  .carousel-cta-btn {
    font-size: 16px !important;
    padding: 18px 36px !important;
  }

  .content-badge {
    font-size: 12px !important;
    padding: 7px 16px !important;
  }
}

@media (max-width: 600px) {
  .modern-carousel-wrapper {
    margin: 0 !important;
    border-radius: 20px !important;
  }

  .modern-carousel {
    border-radius: 20px !important;
  }

  .carousel-overlay {
    padding: 28px 16px !important;
    border-radius: 20px !important;
  }

  .carousel-title {
    font-size: 24px !important;
    margin-bottom: 10px !important;
  }

  .carousel-subtitle {
    font-size: 14px !important;
    margin-bottom: 20px !important;
  }

  .carousel-cta-btn {
    font-size: 14px !important;
    padding: 14px 28px !important;
  }

  .carousel-cta-btn .v-icon {
    font-size: 18px !important;
  }

  .content-badge {
    font-size: 11px !important;
    padding: 6px 14px !important;
    margin-bottom: 14px !important;
  }

  .custom-dots {
    bottom: 12px !important;
    gap: 8px !important;
    padding: 8px 16px !important;
  }

  .dot {
    width: 10px !important;
    height: 10px !important;
  }

  .dot.active {
    width: 24px !important;
  }
}
</style>
